export default "__VITE_ASSET__DX_Ci_pQ__"